import { render, staticRenderFns } from "./BookVersionConfig.vue?vue&type=template&id=06f8d7ea&scoped=true"
import script from "./BookVersionConfig.vue?vue&type=script&lang=js"
export * from "./BookVersionConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f8d7ea",
  null
  
)

export default component.exports